module.exports = __webpack_public_path__ + "static/img/zaixian.2f5b101.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productlist/zaixian.jpg
// module id = nCZb
// module chunks = 1